/**
 * Interface for the 'FeatureToggle' data
 */
export interface FeatureToggleEntity {
  id: string | number; // Primary ID
  name: string;
}
